module.exports = __webpack_public_path__ + "static/Rishav_Resume-62f3e76cbbaa27ef6dd0156b200f3a9a.pdf";